import { ServiceProvider } from '@Common/Core/ServiceProvider.generated';

export const serviceMethodErrors = {
    addUsersToAdmitted: strings.licenseManagerEditor.namedUsersExceeded,
    addUsersToRejected: undefined,
    calculateRegressionMetric: undefined,
    changeDimensionIds: strings.couldntChangeDimensionId,
    changePassword: undefined,
    changeTestCaseComment: undefined,
    checkDatabaseExist: strings.couldntCheckDatabase,
    checkDataLoad: undefined,
    checkDbVersion: strings.couldntCheckDatabase,
    checkDocumentBeforeSave: strings.couldntSaveDocument,
    checkFtpServer: strings.couldntChekFTP,
    checkProjectBeforePublish: strings.couldntValidate,
    checkSession: undefined,
    clearCache: strings.couldntClearCache,
    clearDataLoadLog: undefined,
    copyDocument: strings.couldntCopyDocument,
    copyTestRunToExpected: undefined,
    createProject: strings.creatingProjectFailed,
    deleteAllEndedProfilerSessions: undefined,
    deleteDataForDocument: strings.couldntDeleteData,
    deleteDocument: undefined,
    deleteEndedProfilerSessions: undefined,
    deleteGlobalObjectById: undefined,
    deleteGlobalObjects: undefined,
    deleteHistory: strings.couldntDeleteDataLoadHistory,
    deleteJob: strings.couldntLoadJobList,
    deleteLicense: undefined,
    deleteTaskLogs: strings.couldntDeleteTask,
    deleteTestRunSession: undefined,
    deleteUploadedFile: strings.couldntMakeUpload,
    downloadFile: undefined,
    editRecord: strings.couldntSaveGridData,
    eMailTestRunSession: undefined,
    executeQuery: strings.couldntExecuteQuery,
    executeWSCall: strings.couldntExecuteServiceCall,
    exportAdminData: strings.couldntPrepareExport,
    exportLogArchive: strings.couldntExportLog,
    exportLogs: undefined,
    exportProjectData: strings.couldntPrepareExport,
    exportToExcel: undefined,
    extractToFormattedExcel: undefined,
    findBestAppropriateGroup: strings.olapMetric.serviceErrorMessage,
    findDocumentUsages: strings.couldntFindDocumentUsages,
    fixBrokenReferences: undefined,
    generateLocalizationTables: strings.couldntGenerateLocalization,
    generateQueryForDocument: strings.couldntGenerateQuery,
    generateRModel: undefined,
    generateStandardMetricQuery: strings.couldntGenerateQuery,
    getAdminDashboardData: undefined,
    getAdminImportData: strings.couldntPrepareExport,
    getAllGlobalObjects: undefined,
    getAllNamedUsers: undefined,
    getAllProfilerSessions: undefined,
    getAuditItems: undefined,
    getBatchFiles: strings.couldntLoadBatchFilesNames,
    getBrokenReferences: undefined,
    getCachedModel: strings.couldntLoadGlobalDocuments,
    getCurrentProfilerSession: undefined,
    getData: strings.couldntLoadComponentData,
    getDataDatabaseType: strings.couldntLoadDocument,
    getDataLoadHistory: strings.couldntLoadDataLoadHistory,
    getDataSourceTable: strings.couldntLoadDatasourceTable,
    getDescriptorsByCategoryies: strings.couldntLoadDescriptorsByCategory,
    getDirectoryItems: undefined,
    getDocumentFolders: strings.couldntLoadDocumentFolders,
    getDynamicItems: strings.couldntStartDataLoad,
    getExportDocuments: strings.couldntPrepareExport,
    getGeoLayerDataDef: strings.couldntProcessShapefile,
    getGlobalObject: undefined,
    getGlobalPlanProjectDimensions: undefined,
    getGlobalPlanProjectDocuments: undefined,
    getGuideData: strings.couldntGetGuideData,
    getImportResult: strings.couldntMakeImport,
    getJobErrors: strings.couldntLoadJobList,
    getJobList: strings.couldntLoadJobList,
    getJobLog: strings.couldntLoadJobList,
    getLicenseSetting: undefined,
    getLogFromScheduler: strings.couldntLoadDataLoadLog,
    getManifestAnalysisStatus: undefined,
    getMapData: strings.couldntLoadMapData,
    getMetricData: strings.couldntGetMetricData,
    getModel: undefined,
    getOperationResult: undefined,
    getProcessChartData: strings.couldntLoadProcessChart,
    getProcessGridData: strings.couldntLoadProcessGrid,
    getProjectImportData: strings.couldntPrepareExport,
    getProjectsNeedToUpdate: undefined,
    getProjectTestRunSessionState: undefined,
    getRecordDimensionData: strings.couldntLoadComponentData,
    getRModelScript: undefined,
    getSapVariableValues: undefined,
    getScheduledTasks: strings.couldntLoadConsoleItems,
    getSchemas: strings.dataServiceProvider.schemasGettingError,
    getShapefileMetaFields: strings.couldntProcessShapefile,
    getSheetNames: strings.couldntLoadSheetNames,
    getSimpleTestResults: strings.couldntGetDBMappingTestResults,
    getStagingDataSource: strings.couldntLoadStagingConnection,
    getSwimlaneData: strings.couldntLoadSwimlane,
    getTableFields: strings.dataServiceProvider.fieldsGettingError,
    getTableNames: strings.dataServiceProvider.tablesGettingError,
    getTableRecords: strings.dataServiceProvider.tablesGettingError,
    getTaskLogs: strings.couldntLoadJobList,
    getTenantsNeedToUpdate: undefined,
    getTestCaseDetails: undefined,
    getTestCasesTreeView: undefined,
    getTestRuns: undefined,
    getTestRunsCompare: undefined,
    getTestRunSessions: undefined,
    getTrellisProcessChartData: strings.couldntLoadProcessChart,
    getTrellisSwimlaneData: strings.couldntLoadSwimlane,
    getUser: undefined,
    getUserReportSubscriptions: strings.couldntLoadReportsDefinitions,
    getViewerModel: strings.couldntLoadGlobalDocuments,
    importAdminData: strings.couldntMakeImport,
    importProjectData: undefined,
    importSolution: strings.importSolutionFailed,
    isFileExist: strings.couldntMakeUpload,
    isTestFinished: strings.couldntGetDBMappingTestFinished,
    loadCachedProjectModel: undefined,
    loadCachedView: strings.couldntLoadView,
    loadDocument: strings.couldntLoadDocument,
    loadDocumentsByCategory: strings.couldntLoadDocumentsByCategory,
    loadDocumentsByName: undefined,
    loadModelChangeTime: undefined,
    loadProjectChangeTimes: undefined,
    loadProjectModel: undefined,
    loadStudioSettings: strings.couldntLoadStudioSettings,
    loadView: strings.couldntLoadView,
    logLoadedView: undefined,
    previewTemplateFile: strings.couldntLoadFilePreview,
    printReport: strings.couldntPrintReport,
    publish: strings.publishFailed,
    readStatus: undefined,
    removeInsightLog: undefined,
    removeLogs: strings.couldntRemoveLog,
    renameDocument: strings.couldntSaveDocument,
    reSaveAll: undefined,
    runJob: strings.couldntLoadJobList,
    saveBookmark: strings.couldntSaveBookmark,
    saveDocument: strings.couldntSaveDocument,
    saveDocumentDescriptor: strings.couldntSaveDocument,
    saveGlobalObject: undefined,
    saveGlobalObjects: undefined,
    saveHistory: strings.couldntSaveDataLoadHistory,
    saveJob: strings.couldntLoadJobList,
    saveLicense: strings.couldntSaveLicense,
    saveParameters: strings.couldntSaveParameters,
    saveProjectTestRunSession: undefined,
    saveStudioSettings: strings.couldntSaveStudioSettings,
    saveUserReportSubscription: strings.couldntSaveReportSubscription,
    scheduleExecutionPlan: strings.couldntSchedulePlans,
    search: strings.couldntStartSearch,
    sendTestEMail: undefined,
    startCreateProject: undefined,
    startCurrentProfilerSession: undefined,
    startDataLoad: undefined,
    startImportProjectData: strings.couldntMakeImport,
    startImportSolution: undefined,
    startManifestAnalisys: undefined,
    startProjectTestRunSession: undefined,
    startService: strings.couldntStartService,
    startTest: strings.couldntStartDBMappingTest,
    startTestProjectCaseSession: undefined,
    startUpdate: undefined,
    startUpdateTenantsAdmin: undefined,
    startUpdateTenantsProjects: undefined,
    stopCurrentProfilerSession: undefined,
    stopDataLoad: undefined,
    stopDataLoads: undefined,
    stopManifestAnalysis: undefined,
    stopProjectTestRunSession: undefined,
    stopService: strings.couldntStopService,
    stopTest: strings.couldntStopDBMappingTest,
    stopTestProjectCaseSession: undefined,
    testConnection: strings.dataServiceProvider.testConnectionFailed,
    tryDeleteDocuments: strings.couldntRemoveDocument,
    tryLoadDocument: strings.couldntLoadDocument,
    tryLoadDocumentsByReferences: strings.couldntLoadDocument,
    unCancelDataLoads: undefined,
    unsafeDelete: undefined,
    update: undefined,
    updateProfilerSession: undefined,
    updateTableAndSave: strings.couldntSaveDocument,
    uploadFile: strings.couldntMakeUpload,
    writeStatus: strings.couldntChangeMode
} as { [Name in keyof ServiceProvider]: Nullable<string> };
